import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EMPTY, Observable, of} from 'rxjs';
import {LinkService} from '../link.service';
import {Link, LinkType, MockedLink} from '../../models/link';
import {mockProjectReferences} from './project-reference.service.mock';

export const mockLinks: MockedLink[] = [
    {
        id: 1,
        name: 'Test Link',
        link: 'www.google.com',
        type: {
            key: 'ActionPlan',
            value: 'Plan van Aanpak'
        },
        projectReference: mockProjectReferences[0]
    }
];

@Injectable()
export class LinkServiceMock implements LinkService {
    protected http = inject(HttpClient);


    listLinkTypes(): Observable<LinkType[]> {
        return of([
            {key: 'ActionPlan', value: 'Plan van Aanpak'},
            {key: 'ProjectSheet', value: 'Projectblad'},
        ]);
    }

    create(refId: number, link: Link): Observable<Link> {
        const projectReference = mockProjectReferences.find(ref => ref.id === refId);
        if (projectReference) {
            const mockLink = {
                ...link,
                projectReference
            };
            mockLinks.push(mockLink);
            return of(link);
        } else {
            throw Error('404 - reference not found');
        }

    }

    delete(refId: number, link: Link): Observable<void> {
        const projectReference = mockProjectReferences.find(ref => ref.id === refId);
        if (projectReference) {
            const linkIdx = mockLinks.findIndex(ml => ml.id === link.id);
            if (linkIdx !== undefined) {
                mockLinks.splice(linkIdx, 1);
                return EMPTY;
            } else {
                throw Error('404 - link not found');
            }
        } else {
            throw Error('404 - reference not found');
        }
    }

    update(refId: number, link: Link): Observable<Link> {
        const projectReference = mockProjectReferences.find(ref => ref.id === refId);
        if (projectReference) {
            const savedLink = mockLinks.find(ml => ml.id === link.id);
            if (savedLink) {
                savedLink.link = link.link;
                savedLink.name = link.name;
                savedLink.type = link.type;

                return of(link);
            } else {
                throw Error('404 - link not found');
            }
        } else {
            throw Error('404 - reference not found');
        }
    }

    list(refId: number): Observable<Link[]> {
       return of(mockLinks.filter(link => link.projectReference.id === refId));
    }
}
